const ThemeSource = {
  palette: {
    primary: {
      main: "#264653",
      light: "#52717f",
      dark: "#001f2a",
      contrastText: "#e8e8e8",
    },
    secondary: {
      main: "#2a9d8f",
      light: "#64cfbf",
      dark: "#006e62",
      contrastText: "#ffffff",
    },
    yellow: { main: "#e9c46a", light: "#fff79a", dark: "#b4943c" },
    orange: { main: "#f4a261", light: "#ffd390", dark: "#be7334" },
    red: { main: "#e76f51", light: "#ffa07e", dark: "#b04027" },
    success: {
      main: "#4caf50",
      light: "#81c784",
      dark: "#388e3c",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ff9800",
      light: "#ffb74d",
      dark: "#f57c00",
      contrastText: "#ffffff",
    },
    error: {
      main: "#f44336",
      light: "#e57373",
      dark: "#d32f2f",
      contrastText: "#ffffff",
    },
  },
  fonts: ["sans-serif", "Roboto"],
  fontSizes: {
    small: "1em",
    medium: "2em",
    large: "3em",
  },
  border: {
    radius: "3px",
    shadow: "0px 1px 2px 0px",
  },
  typography: {
    h1: {
      fontSize: "1.8em",
      fontWeight: "700",
    },
    h2: {
      fontSize: "1.6em",
      fontWeight: "700",
      marginTop: "1em",
      marginBottom: "0.5em",
    },
    h3: {
      fontSize: "1.3em",
      fontWeight: "500",
      marginTop: "1em",
      marginBottom: "0.5em",
    },
    h4: {
      fontSize: "1.2em",
      fontWeight: "500",
      marginTop: "1em",
      marginBottom: "0.3em",
    },
    body1: {
      fontSize: "1em",
      fontWeight: "500",
      paddingBottom: "1vh",
    },
  },
  overrides: {
    MuiButton: {
      root: {
        fontSize: "18px",
        fontWeight: 600,
        borderRadius: "3px",
        textTransform: "none",
      },
    },
    MuiInputBase: {
      root: {
        fontWedight: "600",
        borderRadius: "3px",
        padding: "0 5px",
      },
      input: {
        "text-align": "center",
      },
    },
  },
};

export default ThemeSource;
